module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/08ec0a98517212b26bd0c4109cb5b08c.png";